import { render, staticRenderFns } from "./TelaAvisoEmail.vue?vue&type=template&id=024668e8&scoped=true&"
import script from "./TelaAvisoEmail.vue?vue&type=script&lang=js&"
export * from "./TelaAvisoEmail.vue?vue&type=script&lang=js&"
import style0 from "./TelaAvisoEmail.vue?vue&type=style&index=0&id=024668e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024668e8",
  null
  
)

export default component.exports